module.exports = __webpack_public_path__ + "static/media/idcard-back-wave3-olive.fc71acb0.png";